import { AdGuardWidget } from '@/components/AdGuardWidget';
import { QBittorrentWidget } from '@/components/QBittorrentWidget';
import { JellyfinWidget } from '@/components/JellyfinWidget';
import { GiteaWidget } from '@/components/GiteaWidget';
import { PelicanWidget } from '@/components/PelicanWidget';

export function IntegrationsRoute() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Apps</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Live stats from AdGuard Home, qBittorrent, Jellyfin, Gitea, and the Pelican
          Minecraft panel. Each widget polls a different upstream service through the
          proxy.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <AdGuardWidget />
        <QBittorrentWidget />
        <JellyfinWidget />
        <GiteaWidget />
        <PelicanWidget />
      </div>
    </div>
  );
}
